import { useSelector, useDispatch } from 'react-redux';

import {
  selectFluxAutomaticControlPanelClassicAcomphDate,
  selectFluxAutomaticControlPanelClassicForecastDate,
  selectFluxAutomaticControlPanelClassicModel,
  setClassicAcomphDate,
  setClassicForecastDate,
  setClassicModel,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';
import { useGetClassicOptionsQuery } from 'services/api/products/flux';
import { ResponseError } from 'services/api/base';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';
import { convertAcomphDateLabel, findAcomphDateLabel } from 'helper/flux/automatic';

export default function useClassicOptions() {
  const dispatch = useDispatch();
  const { data, error } = useGetClassicOptionsQuery();

  const acomphDateLabel = useSelector(selectFluxAutomaticControlPanelClassicAcomphDate);
  const forecastDateLabel = useSelector(selectFluxAutomaticControlPanelClassicForecastDate);
  const model = useSelector(selectFluxAutomaticControlPanelClassicModel);

  useHandleRequestErrors(error as ResponseError);

  const acomphDateLabels = data ? Object.keys(data) : [];
  const acomphDates = acomphDateLabels.map(convertAcomphDateLabel).reverse() as Date[];
  const acomphDate = convertAcomphDateLabel(acomphDateLabel);

  const forecastDates = data && data[acomphDateLabel]
    ? Object.keys(data[acomphDateLabel]).sort((a, b) => a.localeCompare(b))
    : [];

  const baseModels = data && data[acomphDateLabel] && data[acomphDateLabel][forecastDateLabel]
    ? data[acomphDateLabel][forecastDateLabel]
    : [];
  const models = baseModels.map((m) => m.split('.')[0]);

  const setAcomphDate = (date: Date) => {
    const label = findAcomphDateLabel(date, acomphDateLabels);
    dispatch(setClassicAcomphDate(label));
    dispatch(setClassicForecastDate(''));
    dispatch(setClassicModel(''));
  };

  // Selecionar uma data de simulação invalida o modelo escolhido (a lista de modelos
  // depende do par ACOMPH + data de simulação). O desktop chega aqui por um evento de
  // RadioButton; o mobile, por um OptionRow que só tem o valor — daí as duas assinaturas.
  const setForecastDateValue = (value: string) => {
    dispatch(setClassicForecastDate(value));
    dispatch(setClassicModel(''));
  };

  const setForecastDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForecastDateValue(e.target.value);
  };

  const setModel = (value: string) => {
    dispatch(setClassicModel(value));
  };

  return {
    acomphDateLabel,
    acomphDate,
    forecastDateLabel,
    model,
    acomphDates,
    forecastDates,
    models,
    setAcomphDate,
    setForecastDate,
    setForecastDateValue,
    setModel,
  };
}
